import { Component, OnInit, ViewChild, AfterViewChecked, AfterViewInit } from '@angular/core';
import { version } from '../../../../package.json';
import { UserService } from 'src/app/core/service/user.service';
import * as moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogTemplateComponent } from 'src/app/shared/components/dialog-template/success-dialog-template/success-dialog-template.component';
import { ApiErrorDialogTemplateComponent } from 'src/app/shared/components/dialog-template/api-error-dialog-template/api-error-dialog-template.component';
import { MatSidenavContent } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit,AfterViewInit {

@ViewChild("content") content : MatSidenavContent;

  version=version;
  routerSubscription: Subscription;
  
  constructor(private userService:UserService,private router:Router,private dialog:MatDialog) {
    
    this.router.routeReuseStrategy.shouldReuseRoute = function(){
      return false;
   }

   this.router.events.subscribe((evt) => {
    if (evt instanceof NavigationEnd) {
       // trick the Router into believing it's last link wasn't previously loaded
       this.router.navigated = false;
       // if you need to scroll back to top, here is the right place
       window.scrollTo(0, 0);
    }
});


  }

ngAfterViewInit(){
  this.routerSubscription = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd))
    .subscribe(event => {
        this.scrollToTop();
    });
}

  mode = 'side';

  navItems=[
    {
      name:"sideNav.lbl.userManagement",
      navUrl:"/u",
      icon:"fa-users"
    },
    {
      name:"sideNav.lbl.helperManagement",
      navUrl:"/h",
      icon:"fa-female"
    },
    {
      name:"sideNav.lbl.reportExport",
      navUrl:"/r",
      icon:"fa-file-export"
    }
  ];

  menuItem=[
    {
      name:"common.lbl.profile",
      action:()=>{this.nav('/u/pi')}
    },
    {
      name:"common.lbl.changePassword",
      action:()=>{this.nav('/u/pe')}
    },
    {
      name:"common.lbl.logout",
      action:()=>{this.logout();}
    },
  ];

  nav(path?){
    this.router.navigate([path?path:'/']);
  }

  ngOnInit(): void {
  }

  logout(){
    this.userService.logout().subscribe(x=>{
    const dialogRef = this.dialog.open(SuccessDialogTemplateComponent,{width:"390px",autoFocus:false,data:{content:"common.lbl.logoutSuccess"}});
    dialogRef.afterOpened().subscribe(y=>{
      this.nav('/l');
    });
    },
    error=>{
      this.checkError(error);
    }
    );
  }

  scrollToTop(){
    this.content.scrollTo({left:0,top:0,behavior:"auto"});
  }

  checkError(err) {
    let dialogRef;
    if (err.status != 401)
      dialogRef = this.dialog.open(ApiErrorDialogTemplateComponent, { width: "450px", autoFocus: false, data:  err  });
    dialogRef ?  dialogRef.afterOpened().subscribe(x => { this.nav('/l'); }):this.nav('/l');
  }
}
